exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".font-menu-align-item-3tntv{padding-right:32px}", ""]);

// Exports
exports.locals = {
	"align-item": "font-menu-align-item-3tntv"
};